import {createSelector} from '@ngrx/store';
import {dataStateSelector} from '../data/selector';

export const getProductPartnersSelector = createSelector(
    dataStateSelector,
    (data) => data.productPartners
);
